





























import {Component, Provide, Vue} from 'vue-property-decorator';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
import WarehousePlywoodAuditCreateDialog from '@/views/journals/warehousePlywoodAudit/WarehousePlywoodAuditCreateDialog.vue';
import WarehousePlywoodAuditEditDialog from '@/views/journals/warehousePlywoodAudit/WarehousePlywoodAuditEditDialog.vue';
@Component({
    components: {WarehousePlywoodAuditCreateDialog, CFlexGrid},
})
export default class WarehousePlywoodAudit extends Vue {
    private editDialog = WarehousePlywoodAuditEditDialog;

    onAdd() {
        let createDialog = this.$refs.createDialog as any;
        createDialog.open(null, {
            title: this.$t('Common.Add'),
            saveCallback: async (payload: any) => {
                try {
                    const {data} = await this.$http.post(`${this.$api.journals.warehousePlywoodAudit}/Save`, payload);
                    (this.$refs.fg as any).updateData(data);
                    createDialog.close();
                } catch (e) {
                    if (e?.response.status === 400) {
                        createDialog.setupErrors(e.response.data.errors);
                    } else {
                        createDialog.close();
                    }
                }
            },
        });
    }
    async onApproved(item: any) {
        let payload;
        if (item.IsApproved) {
            try {
                const {data} = await this.$http.get(`${this.$api.journals.warehousePlywoodAudit}/Disapprove`, {
                    params: {
                        id: item.Id,
                    },
                });
                payload = data;
            } catch {}
        } else {
            try {
                const {data} = await this.$http.get(`${this.$api.journals.warehousePlywoodAudit}/Approve`, {
                    params: {
                        id: item.Id,
                    },
                });
                payload = data;
            } catch {}
        }
        if (payload) (this.$refs.fg as any).updateData(payload);
    }

    @Provide()
    async getVocabulary(vm: any) {
        let dc = vm.getDescriptionsContainer();
        const getDescriptionsMap = (descriptions: Array<{Id: number; Description: string}>) => {
            let map = new Map();
            for (const [index, item] of descriptions.entries()) {
                map.set(item.Id, {order: index, text: item.Description});
            }
            return map;
        };
        try {
            const response = await Promise.all([
                dc.get(`${vm.$api.catalogues.warehousePlywood}/GetDescriptions`),
                dc.get(`${vm.$api.catalogues.plywoodGrade}/GetDescriptions`),
                dc.get(`${vm.$api.catalogues.plywoodSize}/GetDescriptions`),
                dc.get(`${vm.$api.catalogues.plywoodThickness}/GetDescriptions`),
                dc.get(`${vm.$api.catalogues.plywoodSpecie}/GetDescriptions`),
                dc.get(`${vm.$api.catalogues.plywoodSurface}/GetDescriptions`),
                dc.get(`${vm.$api.catalogues.plywoodWaterResistance}/GetDescriptions`),
                dc.get(`${vm.$api.measureUnit}/GetDescriptions`),
            ]);
            let map = new Map();
            map.set(vm.$api.catalogues.warehousePlywood, getDescriptionsMap(response[0].data));
            map.set(vm.$api.catalogues.plywoodGrade, getDescriptionsMap(response[1].data));
            map.set(vm.$api.catalogues.plywoodSize, getDescriptionsMap(response[2].data));
            map.set(vm.$api.catalogues.plywoodThickness, getDescriptionsMap(response[3].data));
            map.set(vm.$api.catalogues.plywoodSpecie, getDescriptionsMap(response[4].data));
            map.set(vm.$api.catalogues.plywoodSurface, getDescriptionsMap(response[5].data));
            map.set(vm.$api.catalogues.plywoodWaterResistance, getDescriptionsMap(response[6].data));
            map.set(vm.$api.measureUnit, getDescriptionsMap(response[7].data));
            return map;
        } catch {
            return null;
        }
    }
}
